import React from 'react';
import _ from 'lodash';
import {initReducerContext} from '@someok/simple-reducer-store';

import {DoubleRightOutlined} from '@/icons';

import headerSubTitleActions from './actions';
import styles from './HeaderSubTitle.module.less';
import {Avatar} from 'antd';

const initialState = {
    subTitle: null,
    iconUrl: null,
};

const [
    useHeaderSubTitleStore,
    HeaderSubTitleStoreProvider,
    HeaderSubTitleContext,
] = initReducerContext(initialState, headerSubTitleActions);

export {useHeaderSubTitleStore, HeaderSubTitleStoreProvider, HeaderSubTitleContext};

HeaderSubTitle.propTypes = {};

function HeaderSubTitle() {
    const [{subTitle = '', iconUrl}] = useHeaderSubTitleStore();
    console.log('HeaderSubTitle', subTitle);

    if (_.isEmpty(subTitle)) {
        return null;
    }

    return (
        <h2 className={styles.subTitle}>
            <div style={{display: 'flex', alignItems: 'center'}}>
                <DoubleRightOutlined style={{marginRight: 24}} />
                {iconUrl && <Avatar shape="square" src={iconUrl} alt="icon" />}
                <div style={{marginLeft: 16}}>{subTitle}</div>
            </div>
        </h2>
    );
}

export default HeaderSubTitle;
